import { render, staticRenderFns } from "./parkingInfo.vue?vue&type=template&id=252c640c&scoped=true&"
import script from "./parkingInfo.vue?vue&type=script&lang=js&"
export * from "./parkingInfo.vue?vue&type=script&lang=js&"
import style0 from "./parkingInfo.vue?vue&type=style&index=0&id=252c640c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252c640c",
  null
  
)

export default component.exports